import {
  generatePath,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import InteractiveButton from '../../../components/InteractiveButton/InteractiveButton';
import { PAGE_TITLE } from '../../../constants/common';
import ROUTE from '../../../constants/route-constants';
import { Dispatch, RootState } from '../../../store/store';
import { connect } from 'react-redux';
import React, { useEffect, useMemo } from 'react';
import CycleSettings from '../../../enums/cycle-setting.enum';

type ComponentProps = ReturnType<typeof mapDispatch> & ReturnType<typeof mapState>;

const EditOutlet: React.FC<ComponentProps> = ({ getRecipeById, recipe }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const currentLoc = generatePath(location.pathname, { id: id });

  const availableTabs = useMemo(() => {
    const baseTabs = [{ title: PAGE_TITLE.EDIT_RECIPE, path: ROUTE.EDIT_RECIPE }];
    
    // Only show Recipe Steps for PostWeld recipes
    if (recipe && recipe.mode === CycleSettings.PostWeld) {
      baseTabs.push({ title: PAGE_TITLE.RECIPE_STEPS, path: ROUTE.RECIPE_STEPS });
    }
    
    return baseTabs;
  }, [recipe]);

  const fetchRecipe = async (id: string) => {
    await getRecipeById(id);
  }

  useEffect(() => {
    fetchRecipe(id);
  }, [location]);

  return (
    <div className="c-recipes-edit-outlet flex gap-y-2 flex-col">
      <div className="flex items-center gap-x-2 rounded-full">
        {availableTabs.map((item) => {
          return (
            <InteractiveButton
              key={item.title}
              text={item.title}
              onClick={() =>
                navigate(generatePath(item.path, { id }))
              }
              customType={`bg-primary font-medium border border-burnt-orang hover:bg-[#ff9146] active:bg-[ff6700] ${currentLoc.includes(
                generatePath(item.path, { id })
              )
                ? 'bg-primary text-white'
                : 'bg-white text-black'
              }`}
            />
          );
        })}
      </div>
      <Outlet />
    </div>
  );
};

const mapDispatch = (dispatch: Dispatch) => ({
  getRecipeById: dispatch.recipes.getRecipe,
});

const mapState = (state: RootState) => ({
  recipe: state.recipes.recipe,
});

export default connect(mapState, mapDispatch)(EditOutlet);
